import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AxiosInstance from './AxiosInstance';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import ToastNotification from './ToastNotification';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [passwordVisible, setPasswordVisible] = useState(false);
    const toastRef = useRef(null);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const showToast = (message, type = "danger") => {
        if (toastRef.current) {
            toastRef.current.showToast(message, type);
        }
    };

    const handleLogin = (e) => {
        e.preventDefault();

        AxiosInstance.post('/common/login', { username, password })
            .then((res) => {
                if (res.data && res.data.role) {
                    const { role, employeeId, accessToken, refreshToken } = res.data;

                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', refreshToken);
                    localStorage.setItem('employeeId', employeeId);

                    if (role === 'admin') {
                        navigate('/admin-dashboard');
                    } else if (role === 'employee') {
                        navigate('/home', { state: { employeeId } });
                    } else {
                        showToast('Unknown role. Contact administrator.');
                    }
                } else {
                    showToast('Invalid login! Please try again.');
                }
            })
            .catch((err) => {
                if (err.response?.status === 401) {
                    // Clean and specific for wrong credentials
                    showToast('Login failed. Username or Password is incorrect!');
                } else {
                    // Optional: only log in development
                    if (process.env.NODE_ENV === 'development') {
                         showToast('Login Error:', err);
                    }
                    showToast('Something went wrong. Please try again later.');
                }
            });
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: 'rgb(248, 248, 248)' }}>
            <div className="card p-4" style={{ maxWidth: '400px', width: '100%' }}>
                <h2 className="text-center">User Login</h2>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <div className="input-group">
                            <input
                                type={passwordVisible ? 'text' : 'password'}
                                className="form-control"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={togglePasswordVisibility}
                                style={{ borderLeft: 'none' }}
                            >
                                {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary w-100" style={{ backgroundColor: 'black', borderColor: 'black' }}>
                        Login
                    </button>
                </form>
            </div>

            {/* Toast Notification */}
            <ToastNotification ref={toastRef} />
        </div>
    );
};

export default Login;
